import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const logInAccountModalFeature = isFeature('3promo-enable-log-in-account-modal');
/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_POPUP_ID = 'log-in-account-modal';
/** Ключ для локалстораджа от попапа */
export const storageKeyForPopup = `3promo:${PROMO_POPUP_ID}`;
